<template>
    <div class="layout__container">

        <div class="layout__width-90 layout__padding-clear">

            <el-form :model="order" ref="order" :rules="rules" class="layout__position-left layout__width-100">
                <div class="component__forms-2 layout__border__all-1px-grey">
                    <div class="text__colour-teal text__size-18 layout__margin__top-20px layout__padding__left-20px">
                        Order Summary
                    </div>
                    <div class="component__forms-2">
                        <div class="layout__padding-20px">

                            <p class="text_colour-909399 text__size-16">Order ID</p>
                            <p class="component__form__values" v-if="this.order.orderId">{{this.order.orderId}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Created</p>
                            <p class="component__form__values" v-if="this.order.created">{{formatDateDDMMYYYYCreated(this.order)}}</p>
                            <p class="text__size-16" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Source</p>
                            <p class="text__size-16" v-if="this.order.source">{{this.order.source}}</p>
                            <p class="text__size-16" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Source ID</p>
                            <p class="text__size-16" v-if="this.order.sourceId">{{this.order.sourceId}}</p>
                            <p class="text__size-16" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Order No</p>
                            <p class="text__size-16" v-if="this.order.orderNo">{{this.order.orderNo}}</p>
                            <p class="text__size-16" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Basket Id</p>
                            <p class="component__form__values" v-if="this.order.basketId">{{this.order.basketId}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Product Cat 1</p>
                            <p class="component__form__values" v-if="this.order.productCat1">
                                {{this.order.productCat1}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Product Cat 2</p>
                            <p class="component__form__values" v-if="this.order.productCat2">
                                {{this.order.productCat2}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Product Cat 3</p>
                            <p class="component__form__values" v-if="this.order.productCat3">
                                {{this.order.productCat3}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Type</p>
                            <p class="component__form__values" v-if="this.order.type">{{this.order.type}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Branch</p>
                            <p class="component__form__values" v-if="this.order.branch">{{this.order.branch}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Contact</p>
                            <p class="component__form__values" v-if="this.order.contact">{{this.order.contact}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Name</p>
                            <p class="component__form__values" v-if="this.order.name">{{this.order.name}}</p>
                            <p class="component__form__values" v-else>-</p>
                        </div>
                    </div>
                    <div class="layout__position-left component__forms-2 text__align-left">
                        <div class="layout__padding-20px">
                            <p class="text_colour-909399 text__size-16">Press</p>
                            <p class="component__form__values" v-if="this.order.press">{{this.order.press}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Style</p>
                            <p class="component__form__values" v-if="this.order.style">{{this.order.style}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Paper Type</p>
                            <p class="component__form__values" v-if="this.order.paperType">{{this.order.paperType}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Paper Weight</p>
                            <p class="component__form__values" v-if="this.order.paperWeight">
                                {{this.order.paperWeight}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Finishing</p>
                            <p class="component__form__values" v-if="this.order.finishing">{{this.order.finishing}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Product Code</p>
                            <p class="component__form__values" v-if="this.order.productCode">
                                {{this.order.productCode}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Quantity</p>
                            <p class="component__form__values" v-if="this.order.quantity">{{this.order.quantity}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Job Name</p>
                            <p class="component__form__values" v-if="this.order.jobName">{{this.order.jobName}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Email</p>
                            <p class="component__form__values" v-if="this.order.email">{{this.order.email}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Product Name</p>
                            <p class="component__form__values" v-if="this.order.productName">
                                {{this.order.productName}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Order Filename</p>
                            <p class="component__form__values" v-if="this.order.orderFilename">
                                {{this.order.orderFilename}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Job Filename</p>
                            <p class="component__form__values" v-if="this.order.jobFilename">
                                {{this.order.jobFilename}}</p>
                            <p class="component__form__values" v-else>-</p>

                        </div>
                    </div>
                    <div class="layout__padding-clear layout__padding-0-20">
                        <el-form-item prop="specialInstructions" class="">
                            <p class="text_colour-909399 text__size-16">Special Instructions</p>
                            <el-input type="textarea" :rows="5" v-model="order.specialInstructions"
                                      class="layout__position-left">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="component__forms-2 layout__border__all-1px-grey layout__margin__bottom-25px">
                    <div class="layout__padding-20px">
                        <div class="text__colour-teal text__size-18">Tracking Information</div>
                        <div class="component__columns-3">
                            <p class="text_colour-909399 text__size-16">Status</p>
                            <p class="component__form__values" v-if="this.order.status">{{this.order.status}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Ordered</p>
                            <p class="component__form__values" v-if="this.order.ordered">{{formatDateDDMMYYYY(this.order)}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Printed</p>
                            <p class="component__form__values" v-if="this.order.printed">{{formatDateDDMMYYYYPrinted(this.order)}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                        </div>
                        <div class="component__columns-3">
                            <p class="text_colour-909399 text__size-16">Finished</p>
                            <p class="component__form__values" v-if="this.order.finished">{{formatDateDDMMYYYYFinished(this.order)}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Despatched</p>
                            <p class="component__form__values" v-if="this.order.despatched">
                                {{formatDateDDMMYYYYDepatched(this.order)}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Despatched Type</p>
                            <p class="component__form__values" v-if="this.order.despatchedType">
                                {{this.order.despatchedType}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                        </div>
                        <div class="component__columns-3">
                            <p class="text_colour-909399 text__size-16">Tracking No</p>
                            <p class="component__form__values" v-if="this.order.depatchId">
                                {{this.order.depatchId}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Supplier</p>
                            <p class="component__form__values" v-if="this.order.plant">{{this.order.plant}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Job ID</p>
                            <p class="component__form__values" v-if="this.order.jobId">{{this.order.jobId}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                        </div>
                    </div>
                </div>

                <div class="component__forms-2 layout__border__all-1px-grey layout__margin__bottom-25px">
                    <div class="layout__padding-20px">
                        <div class="text__colour-teal text__size-18">Order Information</div>
                        <div class="component__columns-3">
                            <div class="layout__margin__right-20px">
                                <p class="text_colour-909399 text__size-16">Invoice No</p>
                                <p class="component__form__values" v-if="this.order.invoiceNo">
                                    {{this.order.invoiceNo}}</p>
                                <p class="component__form__values" v-else>-</p>
                                <br>
                                <p class="text_colour-909399 text__size-16">Invoiced</p>
                                <p class="component__form__values" v-if="this.order.invoiced">
                                    {{this.order.invoiced}}</p>
                                <p class="component__form__values" v-else>-</p>
                                <br>
                                <p class="text_colour-909399 text__size-16">Ledger Branch</p>
                                <p class="component__form__values" v-if="this.order.ledgerBranch">
                                    {{this.order.ledgerBranch}}</p>
                                <p class="text__size-16" v-else>-</p>
                                <br>
                                <p class="text_colour-909399 text__size-16">FOC Reason</p>
                                <div class="">
                                    <el-form-item prop="focReason" class="">
                                        <el-select v-model="order.focReason" placeholder="Select FOC reason"
                                                   clearable="true"
                                                   :disabled="order.status != 'FOC'">
                                            <el-option
                                                    v-for="status in ravensworth.focReason.options"
                                                    :key="status.id"
                                                    :label="status.text"
                                                    :value="status.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <p class="text_colour-909399 text__size-16">Price Code</p>
                            <p class="component__form__values" v-if="this.order.priceCode">
                                {{this.order.priceCode}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                        </div>
                        <div class="component__columns-3">
                            <div class="layout__margin__right-20px">
                                <p class="text_colour-909399 text__size-16">Bill Status</p>
                                <p class="component__form__values" v-if="this.order.billStatus">
                                    {{this.order.billStatus}}</p>
                                <p class="component__form__values" v-else>-</p>
                                <br>
                                <p class="text_colour-909399 text__size-16">Bill Month</p>
                                <p class="component__form__values" v-if="this.order.billMonth">
                                    {{this.order.billMonth}}</p>
                                <p class="component__form__values" v-else>-</p>
                                <br>
                                <p class="text_colour-909399 text__size-16">Bill Year</p>
                                <p class="component__form__values" v-if="this.order.billYear">
                                    {{this.order.billYear}}</p>
                                <p class="component__form__values" v-else>-</p>
                                <br>
                                <el-form-item prop="billQuantity">
                                    <p class="text_colour-909399 text__size-16">Bill Qty<span
                                            class="text__colour-red">*</span>
                                    </p>
                                    <el-input v-model="order.billQuantity" class="layout__position-left"
                                              clearable>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="component__columns-3">

                            <el-form-item prop="billPrice">
                                <p class="text_colour-909399 text__size-16">Unit Price<span
                                        class="text__colour-red">*</span></p>
                                <el-input v-model="order.billPrice" class="layout__position-left">
                                </el-input>
                            </el-form-item>
                            <p class="text_colour-909399 text__size-16">Net Total</p>
                            <p class="component__form__values" v-if="this.order.billNetTotal">
                                {{this.returnFormattedCurrency(this.order.billNetTotal)}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <el-form-item prop="billVatRate" class="">
                                <p class="text_colour-909399 text__size-16">VAT %</p>
                                <p class="component__form__values" v-if="this.order.billVatRate">
                                    {{this.order.billVatRate}}</p>
                                <p class="component__form__values" v-else>-</p>
                            </el-form-item>
                            <p class="text_colour-909399 text__size-16">VAT Total</p>
                            <p class="component__form__values" v-if="this.order.billVatTotal">
                                {{this.returnFormattedCurrency(this.order.billVatTotal)}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                            <p class="text_colour-909399 text__size-16">Gross Total</p>
                            <p class="component__form__values" v-if="this.order.billGrossTotal">
                                {{this.returnFormattedCurrency(this.order.billGrossTotal)}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                        </div>
                        <div class="layout__padding-clear">
                            <el-form-item prop="billDescription" class="">
                                <p class="text_colour-909399 text__size-16">Bill Description<span
                                        class="text__colour-red">*</span></p>
                                <el-input type="textarea" :rows="4" v-model="order.billDescription"
                                          class="layout__position-left">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="billComments" class="">
                                <p class="text_colour-909399 text__size-16">Bill Comments</p>
                                <el-input type="textarea" :rows="4" v-model="order.billComments"
                                          class="layout__position-left">
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>

                <div class="component__forms-2 layout__margin__bottom-25px">
                    <div class="layout__padding-clear">


                        <div class="">
                            <el-button
                                    class="button-red button__base__admin layout__position-left layout__margin__right-20px layout__margin__bottom-10"
                                    v-on:click="updateOrder('order')">Save Changes
                            </el-button>
                            <el-button
                                    class="button-teal button__base__admin layout__position-left layout__margin__right-20px layout__margin__bottom-10"
                                    v-on:click="cancelChanges()">Cancel Changes
                            </el-button>
                            <el-button
                                    class="button-teal button__base__admin layout__position-left layout__margin__right-20px layout__margin__bottom-10"
                                    v-on:click="">Cancel Order
                            </el-button>
                        </div>
                        <div id="message"></div>

                    </div>
                </div>

            </el-form>


        </div>

    </div>

</template>

<script>
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "adminOrders",
        mixins: [axios, dataFormatter, backing],
        data() {
            const validateStatus = (rule, value, callback) => {

                if (this.order.status === 'FOC' && this.order.focReason === null) {
                    callback(new Error('Select a free of charge reason'));
                } else {
                    callback();
                }
            };
            return {
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/orderSearchById`,
                order: {},
                rules: {
                    focReason: [{
                        validator: validateStatus, trigger: 'change'
                    }],
                    billPrice: [{
                        required: true,
                        message: 'unit price required',
                        trigger: 'blur'
                    }],
                    billDescription: [{
                        required: true,
                        message: 'bill description required',
                        trigger: 'blur'
                    }],
                    billQuantity: [{
                        required: true,
                        message: 'bill quantity required',
                        trigger: 'blur'
                    }],
                },
            }
        },
        beforeUpdate() {
        },
        created() {
            this.isUserAuthorised();
            let getOrderById = this.serviceRouteUrl + '?sourceId=' + this.$route.query.id + '&source=' + this.$route.query.source
            Axios.get(getOrderById, this.returnHeaderUsingToken())
                .then(response => {
                    this.order = response.data.results[0]
                    window.sessionStorage.setItem('_adminOrder', JSON.stringify(this.order));

                })
                .catch(error => {
                    console.log(error)
                })


            // if (typeof this.order === 'undefined') {
            //     if (window.sessionStorage.getItem('_adminOrder') !== null) {
            //         this.order = JSON.parse(window.sessionStorage.getItem('_adminOrder'))
            //         //
            //         //     console.log(this.order)
            //     }
            // } else {
            //     window.sessionStorage.setItem('_adminOrder', JSON.stringify(this.order));
            // }



        },
        methods: {
            updateOrder(order) {
                this.$refs[order].validate((valid) => {
                    if (valid) {
                        console.log('done post')

                        const updateOrderUri = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Order/Patch`

                        let updateOrder = {
                            "orderNo": this.order.orderNo,
                            "specialInstructions": this.order.specialInstructions,
                            "jobId": this.order.jobId,
                            "plant": this.order.plant,
                            "billDescription": this.order.billDescription,
                            "billQuantity": this.order.billQuantity,
                            "billPrice": this.order.billPrice,
                            "billComments": this.order.billComments,
                            "id": this.order.id,
                            "status": this.order.status,
                            "focReason": this.order.focReason,
                        }

                        const loading = this.$loading({
                            lock: true,
                            text: 'Saving Changes to order',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });


                        Axios.patch(updateOrderUri, updateOrder, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response)

                                // todo this comes back in lowercase needs to be the same
                                this.order = response.data.result
                                window.sessionStorage.setItem('_adminOrder', JSON.stringify(this.order));

                                document.getElementById("message").innerText = "Order Successfully Updated"
                                document.getElementById("message").classList.add('component__message-base', 'component__message-success', 'layout__display-block')

                                loading.close()
                            })
                            .catch(error => {
                                document.getElementById("message").innerText = "There was a problem updating the order - please try again"
                                document.getElementById("message").classList.add('component__message-base', 'component__message-fail', 'layout__display-block')

                                loading.close()
                            })

                        console.log(updateOrder)

                        // todo the axios call
                        // todo take the updated order and put in the order object

                    } else {
                        return false;
                    }
                })
            },
            focOrderStatus() {

                this.order.status = 'FOC'
                // const updateOrderUri = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Order/UpdateOrderStatus`
                //
                //
                // let updateStatus = {
                //     "orderStatus": 'FOC',
                //     "orderSourceId": this.order.sourceId,
                //     "orderSource": this.order.source
                // }
                //
                // console.log(updateStatus)
                //
                // Axios.put(updateOrderUri, updateStatus, this.returnHeaderUsingToken())
                //     .then(response => {
                //         console.log(response)
                //     })
                //     .catch(error => {
                //     })

            },
            despatchedOrderStatus() {

                this.order.status = 'DESPATCHED'
                // const updateOrderUri = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Order/UpdateOrderStatus`
                //
                //
                // let updateStatus = {
                //     "orderStatus": 'DESPATCHED',
                //     "orderSourceId": this.order.sourceId,
                //     "orderSource": this.order.source
                // }
                //
                // console.log(updateStatus)
                //
                // Axios.put(updateOrderUri, updateStatus, this.returnHeaderUsingToken())
                //     .then(response => {
                //         console.log(response)
                //     })
                //     .catch(error => {
                //     })

            },
            cancelChanges() {
                this.order = JSON.parse(window.sessionStorage.getItem('_adminOrder'))
            }

        },
    };
</script>